function detectTimezone() {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return timezone || "UTC";
}
export async function signUp(supabase, { email, password }) {
    const timezone = detectTimezone();
    const { data, error } = await supabase.auth.signUp({ email, password });
    if (error) {
        return { data, error };
    }
    const userId = data.user?.id;
    if (!userId) {
        return { data, error: null };
    }
    const { error: profileError } = await supabase.from("users").upsert({
        id: userId,
        email,
        timezone
    });
    if (profileError) {
        return { data, error: profileError };
    }
    return { data, error: null };
}
export async function signIn(supabase, { email, password }) {
    return supabase.auth.signInWithPassword({ email, password });
}
export async function signInWithMagicLink(supabase, { email, emailRedirectTo }) {
    const options = emailRedirectTo ? { emailRedirectTo } : undefined;
    return options
        ? supabase.auth.signInWithOtp({ email, options })
        : supabase.auth.signInWithOtp({ email });
}
export async function signOut(supabase) {
    return supabase.auth.signOut();
}
